/**
 * useProviderReferralLink Hook
 * Feature: 012-care-seeker-invite-signup (T061)
 *
 * React Query hook to fetch the Service Provider's referral link.
 */

import { useQuery } from '@tanstack/react-query';
import { fetchProviderReferralLink, type ReferralLinkResponse } from '../api/referralLinkApi';

/**
 * Hook to fetch the Service Provider's referral link
 *
 * @returns Query result with referral link data
 *
 * @example
 * ```tsx
 * const { data, isLoading, isError } = useProviderReferralLink();
 * if (data) {
 *   console.log(data.referralLink); // Full shareable URL
 *   console.log(data.referralCode); // 8-char code
 * }
 * ```
 */
export const useProviderReferralLink = () => {
  return useQuery<ReferralLinkResponse>({
    queryKey: ['provider', 'referralLink'],
    queryFn: fetchProviderReferralLink,
    staleTime: Infinity, // Referral link doesn't change
    retry: 1,
  });
};
